module.exports = __webpack_public_path__ + "static/media/HL16.1d2dde50.jpg";